<template>
    <Calendar id="constant" dateFormat="dd-mm-yy" v-model="calendarDate" :showIcon="true" @date-select="loadDate" @input="loadDate" :class="{ 'p-invalid': props.isInvalid }" />
</template>

<script setup>
import { ref, onMounted, defineProps, defineEmits } from 'vue';
import { formatDate, formatRequestDate } from '../../../helpers/date-formatter';
const emit = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: {
        type: [String, Number],
    },
    isInvalid: {
        type: Boolean,
    },
});
const calendarDate = ref(null);

onMounted(() => {
    if (props.modelValue) {
        calendarDate.value = formatDate(props.modelValue);
    }
});

const loadDate = (dateVal) => {
    emit('update:modelValue', formatRequestDate(dateVal));
};
</script>
